import { v4 as uuid } from 'uuid'
import window from '../injectChromeObject'

export const __PRD__ = process.env.NODE_ENV === 'production'
export const __DEV__ = process.env.NODE_ENV === 'development'
export const __TEST__ = process.env.NODE_ENV === 'test'
export const __STORYBOOK__ = Boolean(process.env.STORYBOOK)
export const __CYPRESS__ = Boolean(window.Cypress || process.env.CYPRESS)
export const __PLUGIN_E2E__ = Boolean(process.env.E2E_TESTING)
export const __PLUGIN_DEBUG__ = Boolean(process.env.DEBUG_BUILD)

export const TRACK_EVENT_NAMES = {
  auth: {
    loginStart: 'Login Started',
    loginComplete: 'Login Completed',
    loginError: 'Login Error Occurred',
    logout: 'Log Out Requested',
    logoutError: 'Log Out Error Occurred',
    googleRedirect: 'Returning from Google OAuth',
    referralCodeUsed: 'Referral Code Used'
  },
  commerce: {
    purchaseFunnel: 'Purchase Funnel2',
    institutionalLicenseSeen: 'Institutional User License Notice Seen'
  },
  site: {
    account: {
      myLoops: 'Account Loops Page Visited',
      myActivity: 'Account My Activity Page Visited',
      home: 'Account Home Page Visited',
      profile: 'Account Profile Page Visited',
      referral: 'Account Referral Page Visited',
      notifications: 'Account Notifications Page Visited'
    },
    manageSchool: {
      manageUsers: 'My School Manage Users Page Visited',
      adminInsights: 'My School Admin Insights Page Visited',
      takeSurveyButtonClicked: `My School Admin Insights 'Take the survey' Button Clicked`
    }
  },
  inProduct: {
    upgradeLinkClicked: 'In-Product Upgrade Link Clicked',
    moreInfoClicked: 'In-Product More Info Clicked'
  },
  onboarding: {
    started: 'Onboarding Survey Started',
    surveyComplete: 'Survey Completed',
    schoolNameEntered: 'School Name Entered'
  },
  goals: {
    completed: 'Goal Completed'
  },
  extension: {
    clickedInstall: 'Install Extension Clicked',
    install: 'Extension Installed'
  },
  referral: {
    codeCopied: 'Referrer URL Copied To Clipboard'
  },
  link: {
    download: 'Download Link'
  },
  labs: { testTracking: 'Test Labs Event' },
  emoji: { openSelection: 'Emoji Selection Opened', select: 'Emoji Selected' },
  quota: {
    exhausted: 'Quota Exhausted',
    clickedUpgrade: 'Clicked to Upgrade After Quota Exhausted'
  },
  sharePanel: {
    clicked: 'Mote Share Clicked',
    action: 'Mote Share Action Taken'
  },
  permission: {
    microphone: {
      requestTriggered: 'Microphone Request Triggered',
      requestBlocked: 'Microphone Request Blocked',
      requestEnabled: 'Microphone Request Enabled'
    }
  },
  popup: {
    prompt: {
      shown: 'Additional Permissions Prompt Shown',
      granted: 'Additional Permissions Granted',
      denied: 'Additional Permissions Denied',
      dismiss: 'Additional Permissions Dismissed',
      learnMore: 'Additional Permissions Learn More'
    },
    settings: {
      transcriptionToggled: 'Transcription Opt Out Toggle',
      transcriptLanguageChanged: 'Transcription Language Changed',
      toggleNewUI: 'Rapinoe Mode Toggled',
      toggleStickyMote: 'Sticky Mode Toggled',
      transcriptionToggledRich: 'Transcription Mode Changed'
    }
  },
  error: {
    occurred: 'Error Occurred',
    moteCreateLogin: 'Login Required for Mote Creation',
    accountMismatch: 'Account Mismatch Error Displayed',
    extensionOutdated: 'Extension Out Of Date Shown'
  },
  mote: {
    redirect: 'Embedded Mote link redirected',
    playback: {
      play: 'Mote Playback Started',
      pause: 'Mote Playback Paused',
      end: 'Mote Playback Ended',
      replay: 'Mote Playback Replayed',
      forward: 'Mote Playback Forwarded',
      rewind: 'Mote Playback Rewound',
      speed: 'Mote Playback Speed Changed'
    },
    record: {
      start: 'Mote Recording Started'
    },
    action: {
      download: 'Mote Downloaded Audio',
      create: 'Mote Created Audio',
      delete: 'Mote Deleted Audio',
      insert: 'Mote Inserted Audio',
      edit: 'Edit Saved',
      editTitle: 'Mote Edited Title',
      editTranscript: 'Mote Edited Transcript',
      hideIcon: 'Hiding Mote Icon',
      reaction: {
        added: 'Mote Reaction Added',
        removed: 'Mote Reaction Removed'
      },
      translation: 'Mote Transcript Translation Generated',
      fullTranscript: 'Mote Full Transcript Toggled',
      transcriptCopied: 'Mote Transcript Copied to Clipboard'
    }
  },
  tote: {
    action: {
      create: 'Tote Initiated',
      share: 'Tote Shared'
    }
  },
  loop: {
    disabled: 'Loopiness Disabled',
    action: {
      toggle: 'Loops Activator Toggled',
      onboarding: 'Loops Onboarding Action Taken',
      engage: 'Loop Engaged',
      export: 'Loops Data Exported'
    }
  }
}

export const CARD_TYPES = {
  MOTE: 'mote',
  TOTE: 'tote'
}

export const NODE_TYPES = {
  ELEMENT: 1,
  ATTRIBUTE: 2,
  TEXT: 3
}

export const noop = () => {}
export const CANVAS = 'canvas'
export const GDOCS = 'gdocs'
export const GSLIDES = 'gslides'
export const GSHEETS = 'gsheets'
export const GFORMS = 'gforms'
export const GCLASSROOM = 'gclassroom'
export const GMAIL = 'gmail'
export const GDRIVE = 'gdrive'
export const APPLICATION_NAMES = {
  [GDOCS]: 'Google Docs',
  [GSHEETS]: 'Google Sheets',
  [GSLIDES]: 'Google Slides',
  [GCLASSROOM]: 'Google Classroom',
  [GFORMS]: 'Google Forms',
  [GMAIL]: 'Gmail',
  [GDRIVE]: 'Google Drive',
  [CANVAS]: 'Canvas'
}
export const CANVAS_CREATOR = CANVAS + ' -creator'
export const CANVAS_STUDENT = CANVAS + ' -student'
export const GCLASSROOM_PRIVATE_COMMENTS = GCLASSROOM + '-private-comments'
export const GCLASSROOM_STUDENT_WORK = GCLASSROOM + '-student-work'
export const GCLASSROOM_INSTRUCTIONS = GCLASSROOM + '-instructions'
export const GDRIVE_GCLASSROOM = 'drive-gclass'
export const GCLASSROOM_HOME = GCLASSROOM + '-home'
export const GCLASSROOM_CLASSWORK = GCLASSROOM + '-classwork'
export const GFORMS_CREATOR = GFORMS + '-creator'
export const GFORMS_RESPONSES = GFORMS + '-response'
export const DEFAULT_LOCALE = 'en-US'

export const PREFERRED_LOCALE_STORAGE_KEY = 'mote-auth-preferredLocale'

export const ENGLISH_SPEAKING_LOCALES = ['en-US', 'en-GB']

export const TRANSCRIPTION_LANGUAGES = [
  ['en-US', 'English (US)'],
  ['en-GB', 'English (UK)'],
  ['en-IN', 'English (IN)'],
  ['en-AU', 'English (AU)'],
  ['en-NZ', 'English (NZ)'],
  ['fr-CA', 'French (Canada)'],
  ['fr-FR', 'French (France)'],
  ['es-US', 'Spanish (US)'],
  ['es-ES', 'Spanish (Spain)'],
  ['ar-LB', 'Arabic (Lebanon)'],
  ['ar-AE', 'Arabic (UAE)'],
  ['hy-AM', 'Armenian'],
  ['eu-ES', 'Basque'],
  ['ca-ES', 'Catalan'],
  ['cs-CZ', 'Czech'],
  ['da-DK', 'Danish'],
  ['nl-NL', 'Dutch'],
  ['fi-FI', 'Finnish'],
  ['de-DE', 'German'],
  ['el-GR', 'Greek'],
  ['he-IL', 'Hebrew'],
  ['hu-HU', 'Hungarian'],
  ['id-ID', 'Indonesian'],
  ['ga-IE', 'Irish (Gaelic)'],
  ['it-IT', 'Italian'],
  ['ja-JP', 'Japanese'],
  ['ko-KR', 'Korean'],
  ['zh-CN', 'Mandarin (Simplified)'],
  ['zh-TW', 'Mandarin (Traditional)'],
  ['no-NO', 'Norwegian Bokmål'],
  ['fa-IR', 'Persian'],
  ['pl-PL', 'Polish'],
  ['pt-BR', 'Portuguese (Brazil)'],
  ['pt-PT', 'Portuguese (Portugal)'],
  ['ro-RO', 'Romanian'],
  ['sw-TZ', 'Swahili (Tanzania)'],
  ['sv-SE', 'Swedish'],
  ['th-TH', 'Thai'],
  ['tr-TR', 'Turkish'],
  ['uk-UA', 'Ukrainian'],
  ['cy-GB', 'Welsh']
]

export const RTL_TRANSCRIPTION_LANGUAGES = ['ar-LB', 'ar-AE', 'he-IL', 'fa-IR']

export const UNSUPPORTED_STREAMING_TRANSCRIPTION_LANGUAGES = []

export const LOCALIZATION_LANGUAGES = [
  { code: 'en-US', name: 'English (US)' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'cy-GB', name: 'Cymraeg' },
  { code: 'es-ES', name: 'Español' },
  { code: 'el-GR', name: 'Ελληνικά' },
  { code: 'fr-FR', name: 'Français' },
  { code: 'it-IT', name: 'Italiano' },
  { code: 'ko', name: '한국어' },
  { code: 'zh-CN', name: '普通话' },
  { code: 'zh-TW', name: '普通話' },
  { code: 'ar', name: 'عربى' },
  { code: 'hi-IN', name: 'हिंदी' }
]

export const TRANSLATION_LANGUAGES = [
  ['en', 'English'],
  ['fr', 'French'],
  ['es', 'Spanish'],
  ['ar', 'Arabic'],
  ['hy', 'Armenian'],
  ['nl', 'Dutch'],
  ['de', 'German'],
  ['el', 'Greek'],
  ['ht', 'Haitian Creole'],
  ['iw', 'Hebrew'],
  ['hu', 'Hungarian'],
  ['id', 'Indonesian'],
  ['ga', 'Irish (Gaelic)'],
  ['it', 'Italian'],
  ['ja', 'Japanese'],
  ['ko', 'Korean'],
  ['ms', 'Malay'],
  ['ps', 'Pashto'],
  ['fa', 'Persian'],
  ['pt', 'Portuguese'],
  ['ro', 'Romanian'],
  ['ru', 'Russian'],
  ['sm', 'Samoan'],
  ['sw', 'Swahili'],
  ['tl', 'Tagalog (Filipino)'],
  ['mi', 'Te reo (Maori)'],
  ['th', 'Thai'],
  ['ur', 'Urdu'],
  ['uk', 'Ukrainian'],
  ['vi', 'Vietnamese'],
  ['cy', 'Welsh'],
  ['zh-CN', 'Mandarin (Simplified)'],
  ['zh-TW', 'Mandarin (Traditional)'],
  ['no', 'Norwegian (Bokmål)']
]

export const RTL_TRANSLATION_LANGUAGES = ['ar', 'fa', 'iw', 'ur']

export const MANDATORY_AUTH_PARAMS = {
  accessToken: {
    precedence: ['auth', 'identity']
  },
  userId: {
    precedence: ['identity']
  },
  primaryEmailAddress: {
    precedence: ['identity']
  }
}

export const ALL_AUTH_PARAMS = {
  ...MANDATORY_AUTH_PARAMS,
  useV4Recorder: {
    precedence: ['labs']
  },
  name: {
    precedence: ['identity']
  },
  givenName: {
    precedence: ['identity']
  },
  familyName: {
    precedence: ['identity']
  },
  avatarUrl: {
    precedence: ['identity']
  },
  createdAt: {
    precedence: ['identity']
  },
  legals: {
    precedence: ['identity']
  },
  isGodMode: {
    precedence: ['identity']
  },
  isMinor: {
    precedence: ['identity']
  },
  countryCode: {
    precedence: ['identity']
  },
  loopPrompt: {
    precedence: ['identity']
  },
  displayName: {
    precedence: ['identity']
  },
  inMarketBy: {
    precedence: []
  },
  productStates: {
    precedence: ['entitlements']
  },
  productName: {
    precedence: ['entitlements']
  },
  productEnum: {
    precedence: ['entitlements']
  },
  freeTrialExpiryEpoch: {
    precedence: ['account']
  },
  freeTrialExpired: {
    precedence: ['account']
  },
  isInFreeTrial: {
    precedence: ['account']
  },
  isPaid: {
    precedence: ['entitlements']
  },
  isInstitutional: {
    precedence: ['entitlements']
  },
  isInstitutionalAdmin: {
    precedence: ['entitlements']
  },
  institutionalRole: {
    precedence: ['account']
  },
  institutionName: {
    precedence: ['account']
  },
  quotaResetsAt: {
    precedence: ['entitlements']
  },
  acquiredScopes: {
    precedence: ['auth', 'identity']
  },
  TZOffset: {
    precedence: ['identity']
  },
  createdByGreeting: {},
  anonymousUserId: {},
  anonymousCreatedAt: {},
  referrerCode: {
    precedence: ['identity']
  },
  lastTranslationLanguage: {
    precedence: ['identity']
  },
  canUseBook: {
    precedence: ['entitlements']
  },
  hitBookLimit: {
    precedence: ['entitlements']
  },
  goals: {
    precedence: []
  },
  institutionNameHints: {
    precedence: ['identity']
  },
  affirmativeCarousel: {
    precedence: ['device']
  },
  assistiveCarousel: {
    precedence: ['device']
  },
  recommendedTranscriptionLocale: {
    precedence: ['device']
  },
  recommendedUXLocale: {
    precedence: ['device']
  },
  preferredLocale: {
    precedence: ['identity']
  }, // Identify whether we wanna use v2 pricing
  canMote: {
    precedence: ['entitlements']
  }, // Identify if user can record a mote or not
  canTranscribe: {
    precedence: ['entitlements']
  },
  description: {
    precedence: ['entitlements']
  },
  dateReplacements: {
    precedence: ['entitlements']
  },
  freeMotesMintedEpoch: {
    precedence: ['entitlements.freeMotes']
  },
  /** future time when user will get a balance of 20 (can be changed from server) free mote.
   * This value will be -1 for essential and unlimited subscription
   */
  totalFreeMotes: {
    precedence: ['entitlements.freeMotes']
  },
  /** total free motes assigned to the user. It can either be -1 or a positive integer
   * If it's -1 that means user has access to unlimited motes
   */
  usedFreeMotes: {
    precedence: ['entitlements.freeMotes']
  },
  availableFreeMotes: {
    precedence: ['entitlements.freeMotes']
  },
  /** no of motes used by the user from free motes quota. It can either be -1 or a number between
   * 0 to value of `totalFreeMotes`
   * If it hit the value to `totalFreeMotes` then `canMote` will also flip to false
   * If it's -1 that means user has access to unlimited motes
   */
  isUpgradable: {
    precedence: ['entitlements']
  }, // Property to control the visibility of "Upgrade now" button,
  applyFreeMoteRationing: {
    precedence: ['entitlements']
  } // Describes whether we should apply free motes rationing or not
}

export const CANONICAL_DOMAIN = 's.mote.com'
export const NETWORK_TIMEOUT = 12 * 1000
export const MOTE_LINK_DOMAIN =
  process.env.REACT_APP_MOTE_LINK_DOMAIN || 'https://mote.com/m/'
export const TOTE_LINK_DOMAIN =
  process.env.REACT_APP_TOTE_LINK_DOMAIN || 'https://mote.com/t/'
export const SHORT_LINK_DOMAIN =
  process.env.REACT_APP_SHORT_LINK_DOMAIN || 'https://mote.fyi/'
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || `https://${CANONICAL_DOMAIN}/`
export const HUB_URL = 'https://learn.mote.com/the-hub'
export const CWS_URL =
  'https://chrome.google.com/webstore/detail/mote-voice-notes/ajphlblkfpppdpkgokiejbjfohfohhmk'
export const FETC_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSegLSHSFOqbeFzTlYZhRzNca-XkjW1dHdYELm2DxcWdJbNPzw/viewform?usp=sf_link'
export const STATUS_URL = 'https://mote.statuspage.io/'
export const SUBPROCESSOR_URL =
  'https://support.mote.com/hc/en-us/articles/360045255892'
export const TAW_URL =
  'https://docs.google.com/presentation/u/1/d/1w3z1etlCqo9rPzcb5Paky4SuXmKIOZiroM-mjidPDwo/template/preview'
export const CAREERS_URL = 'https://apply.workable.com/mote/'
export const WEATHERS_URL =
  '/docs/Educational_impact_of_Mote__by_John_Weathers_PhD.pdf'
export const PRESS_URL =
  'https://www.notion.so/justmote/Mote-Press-1b8d3ace9bb44ccd97cec2c4d0e5d432'
export const PRICING_URL = 'https://www.mote.com/pricing'
export const MOTECE_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScofp80GLsF_UyPddoxtTqDIr9Mkz77UhS4Ttfaops24DbIWg/viewform'
export const MOTECON_URL = '/motecon-2022'
export const MOTECON_2021_URL =
  'https://learn.mote.com/2021/08/16/motecon-2021/'
export const LOOPS_URL =
  'https://support.mote.com/hc/en-us/articles/7080352481940'
export const FEEDBACK_URL = 'https://mote.canny.io/feature-requests'
export const SUCCESS_STORIES_URL = 'https://learn.mote.com/success-stories/'
export const TERMS_URL = '/privacy?tab=terms'
export const GDPR_URL = '/privacy?tab=gdpr'
export const PLEDGE_URL = '/privacy?tab=pledge'
export const DATA_SECURITY_URL = '/privacy?tab=security'
export const CASE_STUDIES_URL = '/learning-zone?tab=case'
export const HOW_TO_URL = '/learning-zone?tab=howto'
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI

export const LEGALS_VERSION = 2

export const ADMIN_ALLOW_LIST = [
  'alex@mote.com',
  'aidan@mote.com',
  'fitzwarren@gmail.com',
  'andreas@mote.com',
  'eric@mote.com',
  'jon@mote.com',
  'mackenzie@mote.com',
  'mateusz@mote.com',
  'leo.mateusz@gmail.com',
  'mateusz@gedu.demo.justmote.me',
  'motetester@gmail.com',
  'nathan@mote.com',
  'nathanvanhesteren@gmail.com',
  'nathan@gedu.demo.justmote.me',
  'neoptolemos@mote.com',
  'neostixz@gmail.com',
  'petros@mote.com',
  '9pitops@gmail.com',
  'rob@mote.com',
  'shelly@mote.com',
  'willmjackson@gmail.com',
  'will@mote.com'
]

export const MOTE_DOMAIN_URL_LIST = [MOTE_LINK_DOMAIN, SHORT_LINK_DOMAIN]
export const MOTE_DOMAIN_URL_REGEX = new RegExp(
  `(${MOTE_LINK_DOMAIN}|${SHORT_LINK_DOMAIN})`,
  'i'
)

export const COUNTRIES = {
  af: 'Afghanistan',
  ax: 'Aland Islands',
  al: 'Albania',
  dz: 'Algeria',
  as: 'American Samoa',
  ad: 'Andorra',
  ao: 'Angola',
  ai: 'Anguilla',
  aq: 'Antarctica',
  ag: 'Antigua And Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  aw: 'Aruba',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  by: 'Belarus',
  be: 'Belgium',
  bz: 'Belize',
  bj: 'Benin',
  bm: 'Bermuda',
  bt: 'Bhutan',
  bo: 'Bolivia',
  ba: 'Bosnia And Herzegovina',
  bw: 'Botswana',
  bv: 'Bouvet Island',
  br: 'Brazil',
  io: 'British Indian Ocean Territory',
  bn: 'Brunei Darussalam',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cv: 'Cape Verde',
  ky: 'Cayman Islands',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  cx: 'Christmas Island',
  cc: 'Cocos (Keeling) Islands',
  co: 'Colombia',
  km: 'Comoros',
  cg: 'Congo',
  cd: 'Congo, Democratic Republic',
  ck: 'Cook Islands',
  cr: 'Costa Rica',
  ci: "Cote D'Ivoire",
  hr: 'Croatia',
  cu: 'Cuba',
  cy: 'Cyprus',
  cz: 'Czech Republic',
  dk: 'Denmark',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  ee: 'Estonia',
  et: 'Ethiopia',
  fk: 'Falkland Islands (Malvinas)',
  fo: 'Faroe Islands',
  fj: 'Fiji',
  fi: 'Finland',
  fr: 'France',
  gf: 'French Guiana',
  pf: 'French Polynesia',
  tf: 'French Southern Territories',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  de: 'Germany',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gr: 'Greece',
  gl: 'Greenland',
  gd: 'Grenada',
  gp: 'Guadeloupe',
  gu: 'Guam',
  gt: 'Guatemala',
  gg: 'Guernsey',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hm: 'Heard Island & Mcdonald Islands',
  va: 'Holy See (Vatican City State)',
  hn: 'Honduras',
  hk: 'Hong Kong',
  hu: 'Hungary',
  is: 'Iceland',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran, Islamic Republic Of',
  iq: 'Iraq',
  ie: 'Ireland',
  im: 'Isle Of Man',
  il: 'Israel',
  it: 'Italy',
  jm: 'Jamaica',
  jp: 'Japan',
  je: 'Jersey',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  kr: 'Korea',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: "Lao People's Democratic Republic",
  lv: 'Latvia',
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libyan Arab Jamahiriya',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mo: 'Macao',
  mk: 'Macedonia',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mt: 'Malta',
  mh: 'Marshall Islands',
  mq: 'Martinique',
  mr: 'Mauritania',
  mu: 'Mauritius',
  yt: 'Mayotte',
  mx: 'Mexico',
  fm: 'Micronesia, Federated States Of',
  md: 'Moldova',
  mc: 'Monaco',
  mn: 'Mongolia',
  me: 'Montenegro',
  ms: 'Montserrat',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nl: 'Netherlands',
  an: 'Netherlands Antilles',
  nc: 'New Caledonia',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  nu: 'Niue',
  nf: 'Norfolk Island',
  mp: 'Northern Mariana Islands',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestinian Territory, Occupied',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pn: 'Pitcairn',
  pl: 'Poland',
  pt: 'Portugal',
  pr: 'Puerto Rico',
  qa: 'Qatar',
  re: 'Reunion',
  ro: 'Romania',
  ru: 'Russian Federation',
  rw: 'Rwanda',
  bl: 'Saint Barthelemy',
  sh: 'Saint Helena',
  kn: 'Saint Kitts And Nevis',
  lc: 'Saint Lucia',
  mf: 'Saint Martin',
  pm: 'Saint Pierre And Miquelon',
  vc: 'Saint Vincent And Grenadines',
  ws: 'Samoa',
  sm: 'San Marino',
  st: 'Sao Tome And Principe',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  rs: 'Serbia',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sk: 'Slovakia',
  si: 'Slovenia',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  gs: 'South Georgia And Sandwich Isl.',
  es: 'Spain',
  lk: 'Sri Lanka',
  sd: 'Sudan',
  sr: 'Suriname',
  sj: 'Svalbard And Jan Mayen',
  sz: 'Swaziland',
  se: 'Sweden',
  ch: 'Switzerland',
  sy: 'Syrian Arab Republic',
  tw: 'Taiwan',
  tj: 'Tajikistan',
  tz: 'Tanzania',
  th: 'Thailand',
  tl: 'Timor-Leste',
  tg: 'Togo',
  tk: 'Tokelau',
  to: 'Tonga',
  tt: 'Trinidad And Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tc: 'Turks And Caicos Islands',
  tv: 'Tuvalu',
  ug: 'Uganda',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  gb: 'United Kingdom',
  us: 'United States',
  um: 'United States Outlying Islands',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  ve: 'Venezuela',
  vn: 'Viet Nam',
  vg: 'Virgin Islands, British',
  vi: 'Virgin Islands, U.S.',
  wf: 'Wallis And Futuna',
  eh: 'Western Sahara',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe'
}

export const PULLDOWN_REGIONS = {
  us: {
    name: 'State',
    items: [
      'Alabama',
      'Alaska',
      'American Samoa',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'District of Columbia',
      'Florida',
      'Georgia',
      'Guam',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Palau',
      'Pennsylvania',
      'Puerto Rico',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virgin Island',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming'
    ]
  },
  au: {
    name: 'State or territory',
    items: [
      'Australian Capital Territory',
      'New South Wales',
      'Northern Territory',
      'Queensland',
      'South Australia',
      'Tasmania',
      'Victoria',
      'Western Australia'
    ]
  },
  ca: {
    name: 'Province',
    items: [
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Labrador',
      'Nova Scotia',
      'Ontario',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan'
    ]
  },

  gb: {
    name: 'County',
    items: [
      'Aberdeenshire',
      'Angus',
      'Antrim',
      'Argyll',
      'Armagh',
      'Avon',
      'Ayrshire',
      'Banffshire',
      'Bedfordshire',
      'Berkshire',
      'Berwickshire',
      'Buckinghamshire',
      'Bute',
      'Caithness',
      'Cambridgeshire',
      'Cheshire',
      'Clackmannanshire',
      'Cleveland',
      'Clwyd',
      'Cornwall',
      'Cumbria',
      'Derbyshire',
      'Devon',
      'Dorset',
      'Down',
      'Dumfriesshire',
      'Dunbartonshire',
      'Durham',
      'Dyfed',
      'East Lothian',
      'East Sussex',
      'Essex',
      'Fermanagh',
      'Fife',
      'Gloucestershire',
      'Gwent',
      'Gwynedd',
      'Hampshire',
      'Herefordshire',
      'Hertfordshire',
      'Inverness-shire',
      'Isle of Wight',
      'Kent',
      'Kincardineshire',
      'Kinross-shire',
      'Kirkcudbrightshire',
      'Lanarkshire',
      'Lancashire',
      'Leicestershire',
      'Lincolnshire',
      'London',
      'Londonderry',
      'Merseyside',
      'Mid Glamorgan',
      'Middlesex',
      'Midlothian',
      'Moray',
      'Nairnshire',
      'Norfolk',
      'North Humberside',
      'North Yorkshire',
      'Northamptonshire',
      'Northumberland',
      'Nottinghamshire',
      'Orkney',
      'Oxfordshire',
      'Peeblesshire',
      'Perthshire',
      'Powys',
      'Renfrewshire',
      'Ross-shire',
      'Roxburghshire',
      'Rutland',
      'Selkirkshire',
      'Shetland',
      'Shropshire',
      'Somerset',
      'South Glamorgan',
      'South Humberside',
      'South Yorkshire',
      'Staffordshire',
      'Stirlingshire',
      'Suffolk',
      'Surrey',
      'Sutherland',
      'Tyne and Wear',
      'Tyrone',
      'Warwickshire',
      'West Glamorgan',
      'West Lothian',
      'West Midlands',
      'West Sussex',
      'West Yorkshire',
      'Wigtownshire',
      'Wiltshire',
      'Worcestershire'
    ]
  }
}

export const CURRENCIES = {
  aud: ['au'],
  eur: [
    'ad',
    'at',
    'ax',
    'be',
    'bl',
    'cy',
    'de',
    'ee',
    'es',
    'fi',
    'fr',
    'gf',
    'gp',
    'gr',
    'ie',
    'it',
    'lt',
    'lu',
    'lv',
    'mc',
    'me',
    'mf',
    'mq',
    'mt',
    'nl',
    'pm',
    'pt',
    're',
    'si',
    'sk',
    'sm',
    'tf',
    'va',
    'ws',
    'yt'
  ],
  gbp: ['gb', 'gg', 'jy', 'im'],
  cad: ['ca']
}

export const CLIPBOARD_ANIMATION_TIMEOUT = 1000

export const STORAGE_TIMESTAMP = 'mote-lastAuth'
export const WEB_STORAGE_PREFIX_KEYS = 'mote-auth-'

export const OAUTH_SCOPES = [
  'profile',
  'email',
  'https://www.googleapis.com/auth/drive.file'
]

export const REFERRER_KEY = 'referrerUserId'

// Extension ID whitelist (web app only communicates with whitelisted extensions)
export const CANDIDATE_EXTENSIONS = [
  'ajphlblkfpppdpkgokiejbjfohfohhmk', // Production
  'kbeknjjgcngcoeelocjmjefgmkkmemgh', // Development
  'pjdhnjalalmadopdnagiacmmpdgfkggi' // Debug
]

export const CANDIDATE_EXTENSION_IDS = {
  production: 'ajphlblkfpppdpkgokiejbjfohfohhmk', // Production
  development: 'kbeknjjgcngcoeelocjmjefgmkkmemgh', // Development
  e2e: 'kbeknjjgcngcoeelocjmjefgmkkmemgh', // E2E
  debug: 'pjdhnjalalmadopdnagiacmmpdgfkggi' // Debug
}

export const PRODUCT_ENUM = {
  FREE: 'free',
  ESSENTIAL: 'essential',
  UNLIMITED: 'unlimited'
}

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || `https://www.mote.com/`
export const LOGIN_URL = SITE_URL + 'login?force=1&invoker=extension'
export const SIGNUP_URL = SITE_URL + 'signup?force=1&invoker=extension'
export const ACCOUNT_URL = SITE_URL + 'account'
export const ACTIVITY_URL = SITE_URL + 'activity'
export const CHECKOUT_EXTENSION_REDIRECT_URL = `${SITE_URL}checkout/redirect?invoker=extension`
export const SUPPORT_URL = 'https://support.mote.com/'
export const MILLISECONDS_PER_CHUNK = 250
// export const MAX_SECONDS_PER_MOTE=5;
export const MAX_SECONDS_PER_MOTE = 60 * 5
export const MAX_ADDITIONAL_SECONDS_BEFORE_AUTO_CANCELLING = 2

export const DOM_MUTATION_HYSTERISIS = 100
export const DOM_MUTATION_QUIESCENCE = 1000
export const URL_CHANGE_POLLING_FREQUENCY = 2000

export const SAMPLEABLE_EVENT_WHITELIST = [
  TRACK_EVENT_NAMES.mote.action.hideIcon,
  'Supported Application Page Loaded'
]
export const SAMPLE_CHARS = 'A'.split('')
export const DEFAULT_TRANSCRIPTION_LANGUAGE = TRANSCRIPTION_LANGUAGES[0][0]

export const ERROR_HAS_FAILED = 'has failed'
export const ERROR_TOO_MANY_POLLS = 'too many polls'
export const ANONYMOUS_PREFIX = 'anonymous:from_extension:'
export const DEFAULT_ANONYMOUS_USER_ID = ANONYMOUS_PREFIX + uuid()
export const DEFAULT_ANONYMOUS_CREATED_AT = Math.floor(Date.now() / 1000)
// only update above if there is a new version and you want users to
// see the UpgradeNotification message.
// Can be any non-repeating series, including manifest version numbers
// (though not all extension versions merit a distinct upgrade message,
// which would cause upgrade fatigue)

export const DEBUG_MODE_STORAGE_KEY = 'debugMode'
export const USER_GOAL_STATE = {
  REQUIRED: 'required',
  COMPLETED: 'completed',
  SKIP_FOR_NOW: 'skip_for_now',
  DISMISSED: 'dismissed'
}

export const VALUES_LINKS = [
  {
    id: 'feedback',
    text: 'For Feedback',
    path: '/use-cases/for-feedback'
  },
  {
    id: 'connection',
    text: 'For Connection',
    path: '/use-cases/connect-with-all-learners'
  },
  {
    id: 'diverse',
    text: 'For Diverse Learners',
    path: '/use-cases/diverse-learners'
  },
  {
    id: 'language',
    text: 'For Language Learning',
    path: '/use-cases/for-language-learning'
  }
]

/**
 * @type Record<any, any>
 */
export const VALUES_LINKS_BY_ID = Object.values(VALUES_LINKS).reduce(
  (acc, value) => ({ ...acc, [value.id]: value }),
  {}
)

export const FOR_EDUCATION_LINKS = [
  ...VALUES_LINKS,
  {
    text: 'Info for Schools',
    path: '/for-schools-districts'
  }
]

export const MOTE_CARD_THEME_TO_GRADIENT_MAP = {
  classic: 'white',
  neutral: 'grey.l1',
  mulberry: 'linear-gradient(129.17deg, #AC0AE8 0%, #0A70E8 223.26%)'
}

export const MOTE_CARD_THEME = {
  classic: {
    createdByName: '#212228',
    niceTitle: '#212228',
    background: 'white',
    border: '1px solid #D1D1D1',
    button: {
      color: '#212228',
      hover: {
        background: '#f6f6f9',
        color: '#212228'
      },
      active: {
        background: '#212228',
        color: '#ffffff'
      }
    },
    scrubber: {
      track: {
        empty: { background: 'rgba(33, 34, 40, 0.2)' },
        filled: { background: '#ac0ae8' }
      },
      thumb: { background: '#ac0ae8' },
      tooltip: { color: '#ffffff', background: '#212228' }
    },
    logo: {
      color: '#ac0ae8',
      secondaryColor: '#ffffff'
    },
    waveForm: {
      background: 'rgba(172,10,232,0.2)',
      mixBlendMode: 'normal',
      opacity: 0.2
    },
    pausedState: {
      text: '#212228'
    },
    translation: {
      icon: {
        color: '#212228'
      }
    },
    transcription: {
      text: '#212228',
      icon: {
        color: '#212228',
        hover: {
          background: '#f6f6f9',
          svg: {
            color: '#212228'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    },
    menu: {
      icon: {
        color: '#212228',
        hover: {
          background: '#f6f6f9',
          svg: {
            color: '#212228'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    }
  },
  mulberry: {
    createdByName: '#ffffff',
    niceTitle: '#ffffff',
    background: 'linear-gradient(129.17deg, #AC0AE8 0%, #0A70E8 223.26%)',
    border: '1px solid transparent',
    button: {
      color: '#ffffff',
      hover: {
        background: 'rgba(33, 34, 40, 0.2)',
        color: '#ffffff'
      },
      active: {
        background: '#212228',
        color: '#ffffff'
      }
    },
    scrubber: {
      track: {
        empty: { background: 'rgba(255, 255, 255, 0.2)' },
        filled: { background: '#ffffff' }
      },
      thumb: { background: '#ffffff' },
      tooltip: { color: '#212228', background: '#ffffff' }
    },
    logo: {
      color: '#ffffff',
      secondaryColor: '#ac0ae8'
    },
    waveForm: {
      background: 'rgba(255, 255, 255, 0.5)',
      mixBlendMode: 'soft-light',
      opacity: 0.5
    },
    pausedState: {
      text: 'white'
    },
    translation: {
      icon: {
        color: 'white'
      }
    },
    transcription: {
      text: 'white',
      icon: {
        color: 'white',
        hover: {
          background: 'rgba(33, 34, 40, 0.2)',
          svg: {
            color: 'white'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    },
    menu: {
      icon: {
        color: '#ffffff',
        hover: {
          background: 'rgba(33, 34, 40, 0.2)',
          svg: {
            color: 'white'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    }
  }
}

export const ZENDESK_WIDGET_ALLOWED_PATHS = ['/quote', '/pricing']

export const ANALYTICS_PARAMS_BLACKLIST = [
  'anonymousUserId',
  'anonymousCreatedAt',
  'accessToken',
  'userId',
  'imageURL',
  'quotaResetsAt',
  'productStates',
  'acquiredScopes',
  'goals',
  'isInstitutional'
]

export const MOTE_VISIBILITY_OPTIONS = {
  UNLISTED: 'public',
  PRIVATE: 'private',
  ORGANIZATION: 'organization'
}

export const LEFT_CLICK = ['mousedown', 'mouseup', 'click']
export const KEYBOARD_EVENTS = ['keydown', 'keyup', 'keypress']
export const ONBOARDING_LOOPS_STORAGE_KEY = 'loopsOnboardingSeen'
export const MOTE_DEBUG_US_SCHOOLS_STORAGE_KEY = 'mote-debug-us-schools'
export const MOTE_DEBUG_US_SCHOOLS_LABS_MODE_STORAGE_KEY =
  'mote-debug-us-schools-labs-mode'
